import axios from "axios";
import store from "@/store";
import { Toast } from "vant";
import router from "@/router";
import MyJSBridge from '@/common/NativeClientMethod/index.js'

const specialCodesList = [10001, 10002, 10003, 10004, 10005, 10006, 10007, 10008, 10009, 10010, 10011, 10012, 10013, 10014, 10015, 10016, 10017, 10018, 10021,10023];
let _loadingCount = 0;

const _getShowLoading = (config) => {
  if (!config) return false;
  if (typeof config.showLoading === "boolean") return config.showLoading;
  if (config.meta && typeof config.meta.showLoading === "boolean") return config.meta.showLoading;
  return false;
};

const _startLoading = () => {
  _loadingCount += 1;
  if (_loadingCount === 1) store.commit("setLoading", true);
};

const _endLoading = () => {
  if (_loadingCount <= 1) {
    _loadingCount = 0;
    store.commit("setLoading", false);
    return;
  }
  _loadingCount -= 1;
};
const requests = axios.create({
  //baseURL: "http://8.219.72.238/computility-api/",
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 15000, // 设置超时时间，15S
  //设置loading状态
  loading: false,
});
// 请求拦截器：在发请求之前，请求拦截器可以检测到，可以在请求发出去之前做一些事情
requests.interceptors.request.use(
  (config) => {
    const showLoading = _getShowLoading(config);
    config.__showLoading = showLoading;
    if (showLoading) _startLoading();
    //这里可以添加公共请求头，如携带token（这里先不管token从哪里获取，假设已经定义了const token = ...；）
    config.headers.Authorization = localStorage.getItem("token") || store.state.token;
    // store.state.token || "member:55db008f344148dfadbe288bc1fa7d3e";
    config.headers.language = localStorage.getItem("locale");
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error("请求错误:", error);
    if (error?.config?.__showLoading) _endLoading();
    return Promise.reject(error);
  }
);

// 响应拦截器
requests.interceptors.response.use(
  (res) => {
    // 对响应数据做处理
    return new Promise((resolve) => {
      if (res?.config?.__showLoading) _endLoading();
      if (res.data && res.data.code === 2000) {
        resolve(res.data);
      } else {
        if (res.data.code === 50001) {
          if (process.env.VUE_APP_ENV === "productionApp") {
            store.commit("setToken", "");
            localStorage.removeItem("token");
            //调用原生方法
            MyJSBridge.send("serviceType", { type: "6" });
            Toast.fail(res.data.message || "未授权，请重新登录");
            resolve(res.data || { code: 50001, message: "未授权，请重新登录" });
            return;
          } else {
            Toast.fail(res.data.message || "未授权，请重新登录");
            store.commit("setToken", "");
            localStorage.removeItem("token");
            if (router.currentRoute && router.currentRoute.name !== "Login") {
              router.push({ name: "Login" }).catch(() => { });
            }
            resolve(res.data || { code: 50001, message: "未授权，请重新登录" });
            return;
          }

        }
        // 特殊处理code
        if (specialCodesList.includes(res.data.code)) {
          resolve(res.data);
          return;
        }
        if (res.data.message === "没有实名记录") {
          return;
        } else {
          Toast.fail(res.message || res.data.msg || res.data.message || "请求失败");
          resolve(res.data || { code: -1, msg: "请求失败" });
        }

      }
    });
  },
  (error) => {
    // 对响应错误做处理，例如判断状态码并展示错误信息
    if (error?.config?.__showLoading) _endLoading();
    console.log("响应错误:", error);
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          Toast.fail("未授权，请重新登录");
          break;
        case 500:
          Toast.fail("服务器内部错误");
          break;
        default:
          Toast.fail("未知错误");
      }
    }
    return Promise.resolve(
      error?.response?.data || { code: -1, msg: error?.message || "网络异常" }
    );
  }
);

export default requests;
